// extracted by mini-css-extract-plugin
module.exports = {"body":"ConfirmBonusModal__body--3JDga","confirm":"ConfirmBonusModal__confirm--37G7K"};